/********************************************
 * Hamburger Menu
 ********************************************/
function fnHamburgerMenu() {

    var oBody = $('body'),
        oMenu = $('#full-screen-menu'),
        oMenuItem = oMenu.find('.burger-menu > li');
    // On-click menu
    oBody.on('click', '.hamburger-button', function () {
        $(this).toggleClass('is-active');
        oMenu.toggleClass('is-active');
        if (oMenu.hasClass('is-active')) {
            setTimeout(function () {
                //locoScroll.stop();
                oBody.addClass('is-fixed');
            }, 300)
        } else {
            //locoScroll.start();
            oBody.removeClass('is-fixed');
        }
        return false;
    });

    /*Menu Items Hover*/
    if ($(window).width() > 1024) {
        oMenuItem.mouseover(function () {
            oMenuItem.removeClass('current');
            $(this).addClass('current');
            oMenu.addClass('is-hovered');
        })
            .mouseout(function (e) {
                oMenu.removeClass('is-hovered');
            });
    }

    /*Submenus Toggler*/
    function fnSubmenu() {
        oMenu.on('click', '.menu li.has-submenu', function (e) {
            $('.submenu-items, .menu-item').removeClass('is-active');
            $(this).addClass('is-active');
            $(this).find('.submenu-items').addClass('is-active');
            //e.preventDefault();
        });
    }

    fnSubmenu();


    $(window).resize(function () {
        fnSubmenu();
    });

}
